// =====================================================
// src/app/ccs/services/ccs.service.ts
// Main CCS service following your pattern
// =====================================================

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { 
  SpecialtyGroup, 
  CCSCase, 
  PatientCondition, 
  CaseProgression, 
  CriticalAction 
} from '../models';
import { BASE_URL } from 'src/app/models/globals';

@Injectable({
  providedIn: 'root'
})
export class CcsService {
  private apiUrl = BASE_URL + '/ccs';

  constructor(private http: HttpClient) { }

  // Get all cases grouped by specialty
  getCasesGroupedBySpecialty(): Observable<SpecialtyGroup[]> {
    return this.http.get<SpecialtyGroup[]>(`${this.apiUrl}/getCasesGroupedBySpecialty`);
  }

  // Get all cases as a flat list
  getAllCases(): Observable<CCSCase[]> {
    return this.http.get<CCSCase[]>(`${this.apiUrl}/getAllCases`);
  }

  // Get cases by specialty
  getCasesBySpecialty(specialty: string): Observable<CCSCase[]> {
    return this.http.get<CCSCase[]>(`${this.apiUrl}/getCasesBySpecialty/${specialty}`);
  }

  // Get specific case details
  getCaseById(caseId: number): Observable<CCSCase & PatientCondition> {
    return this.http.get<CCSCase & PatientCondition>(`${this.apiUrl}/getCaseById/${caseId}`);
  }

  // Get case progressions
  getCaseProgressions(caseId: number): Observable<CaseProgression[]> {
    return this.http.get<CaseProgression[]>(`${this.apiUrl}/getCaseProgressions/${caseId}`);
  }

  // Get critical actions for case
  getCriticalActions(caseId: number): Observable<CriticalAction[]> {
    return this.http.get<CriticalAction[]>(`${this.apiUrl}/getCriticalActions/${caseId}`);
  }

  getCaseDetails(caseId: string): Observable<any> {
    console.log(caseId)
    let route = `${this.apiUrl}/getCaseById/${caseId}`
    console.log(route)
    return this.http.get<any>(route);
  }

  // Get physical evaluations
  getPhysicalEvaluations(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/getPhysicalEvaluations`);
  }

  // Get all order details including lists, categories, and types
  getOrderDetails(): Observable<{
    orderList: any[],
    orderCategories: any[],
    orderTypes: any[]
  }> {
    return this.http.get<any>(`${BASE_URL}/getOrders`);
  }
}
